import classnames from 'classnames';
import React, { useState } from 'react';

import styles from '../InputField/InputField.module.css';

import { IInputFileProps } from '@/shared/components/atoms/FileInput/IFileInput';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import { Typography } from '@/shared/components/atoms/Typography';

const FileInput: React.FC<IInputFileProps> = React.forwardRef<
  never,
  IInputFileProps
>(
  (
    {
      label,
      className,
      id,
      prefix,
      suffix,
      error,
      errorMessage,
      disabled,
      py,
      px,
      width,
      textColor,
      fontSize,
      borderColor,
      iconSize,
      iconColor,
      placeholderColor,
      onChange,
      ...props
    },
    ref
  ) => {
    const [newFileSrc, setNewFileSrc] = useState<File | undefined>(undefined);
    const inputClasses = classnames(
      styles['input-field'],
      {
        [styles['error']]: error,
        [styles['disabled']]: disabled,
        [styles['prefix-padding']]: prefix,
        [styles['suffix-padding']]: suffix,

        [styles['default-padding']]: !prefix && !suffix,
      },
      'relative',
      className,
      py,
      px,
      placeholderColor,
      fontSize,
      borderColor,
      textColor
    );
    const inputProps = {
      ...props,
    } as React.InputHTMLAttributes<HTMLInputElement>;

    const labelClasses = classnames(styles['label'], {
      [styles['label-disabled']]: disabled,
    });

    return (
      <div className={`relative flex flex-col ${width}`}>
        {label ? (
          <label htmlFor={id || inputProps?.name} className={labelClasses}>
            <Typography variant='body1' weight='regular'>
              {label}{' '}
              {props?.required && <span className={styles['required']}>*</span>}
            </Typography>
            <div className={inputClasses}>
              <span>
                {newFileSrc?.name ? newFileSrc.name : inputProps.placeholder}
              </span>
              {prefix ? (
                <BaseIcon
                  size={iconSize}
                  svgClasses={`${iconColor} ${styles['icon']}  ${styles['prefix']}`}
                >
                  {prefix}
                </BaseIcon>
              ) : null}
              {suffix ? (
                <BaseIcon
                  size={iconSize}
                  svgClasses={`${iconColor} ${styles['icon']}  ${styles['suffix']}`}
                >
                  {suffix}
                </BaseIcon>
              ) : null}
            </div>
          </label>
        ) : null}
        <div className='relative w-full'>
          <input
            id={id || inputProps?.name}
            ref={ref}
            className='hidden'
            type='file'
            onChange={(e) => {
              if (e.target.files) {
                if (onChange) onChange(e);
                setNewFileSrc(e.target.files[0]);
              }
            }}
            {...inputProps}
          />
        </div>
        {errorMessage && error ? (
          <Typography
            className='mt-8 text-error-default'
            variant='body2'
            weight='regular'
          >
            {errorMessage}
          </Typography>
        ) : null}
      </div>
    );
  }
);

export default FileInput;

FileInput.defaultProps = {
  py: 'py-9',
  px: '',
  textColor: 'text-text-default',
  fontSize: 'text-base',
  borderColor: 'border-background-disable',
  iconSize: 'sm',
  iconColor: '',
  placeholderColor: 'text-text-secondary',
};
